import { component } from 'picoapp';
import noUiSlider from 'nouislider';

export default component(async (node, ctx) => {
  ctx.on('filter:loaded', ({ filter }) => {
    const el = node.querySelector('[data-slider]');
    const price = node.querySelector('[data-price]');
    const minEl = node.querySelector('[data-price-min]');
    const maxEl = node.querySelector('[data-price-max]');

    const updateValues = (min, max) => {
      minEl.innerHTML = Shopify.formatMoney(min * 100, theme.moneyFormat);
      maxEl.innerHTML = Shopify.formatMoney(max * 100, theme.moneyFormat);

      price.dataset.min = Number(min);
      price.dataset.max = Number(max);
    };

    const priceFilter = filter.query.find((item) => item.type === 'price');
    const [min, max] = priceFilter.params;
    const [rangeMin, rangeMax] = priceFilter.values;

    noUiSlider.create(el, {
      start: [min, max],
      step: 1,
      connect: true,
      range: {
        min: [rangeMin],
        max: [rangeMax],
      },
    });

    el.noUiSlider.on('set', (values) => {
      const [minVal, maxVal] = values;
      updateValues(minVal, maxVal);

      const state = ctx.getState();
      ctx.emit('filter:start', state, true);
    });

    el.noUiSlider.on('update', (values) => {
      const [minVal, maxVal] = values;
      updateValues(minVal, maxVal);
    });

    ctx.on('filter:clear', () => {
      el.noUiSlider.set([rangeMin, rangeMax]);
      updateValues(rangeMin, rangeMax);
    });
  });
});
